<picture>
    <source srcset="{{ imagePathWebp }}" type="image/webp">
    <source srcset="{{ imagePath }}" type="{{ typeImage }}">
    <img src="{{ imagePath }}" alt="{{ imageName }}" style="{{ style }}">
</picture>
  